import type { Context } from 'src/models/context';

const defaultContext = { loading: false, isAuthenticated: false, login: null, refresh: null, logout: null };
const useAuthorization = (): Context => defaultContext;


export default useAuthorization;
